import { a as e, n as t } from "./mathjax-2nQh1S7u.js";
//#region ../../../node_modules/.bun/@mathjax+mathjax-newcm-font@4.1.3/node_modules/@mathjax/mathjax-newcm-font/mjs/chtml/dynamic/monospace-ex.js
t.dynamicSetup("", "monospace-ex", e({ MX: { monospace: {
	161: [
		.389,
		.233,
		.525
	],
	162: [
		.524,
		.093,
		.525
	],
	164: [
		.475,
		-.137,
		.525
	],
	166: [
		.694,
		.083,
		.525
	],
	169: [
		.525,
		0,
		.525
	],
	170: [
		.622,
		-.237,
		.525
	],
	171: [
		.531,
		-.081,
		.525
	],
	173: [
		.341,
		-.271,
		.525
	],
	174: [
		.525,
		0,
		.525
	],
	186: [
		.622,
		-.237,
		.525
	],
	187: [
		.531,
		-.081,
		.525
	],
	188: [
		.626,
		.015,
		.525
	],
	189: [
		.626,
		.015,
		.525
	],
	190: [
		.626,
		.015,
		.525
	],
	191: [
		.389,
		.228,
		.525
	],
	3647: [
		.704,
		.093,
		.525
	],
	8218: [
		.092,
		.202,
		.525
	],
	8219: [
		.611,
		-.278,
		.525
	],
	8222: [
		.092,
		.202,
		.525
	],
	8223: [
		.611,
		-.347,
		.525
	],
	8226: [
		.372,
		-.096,
		.525
	],
	8233: [
		.611,
		.222,
		.525
	],
	8240: [
		.694,
		.083,
		.525
	],
	8241: [
		.694,
		.083,
		.525
	],
	8249: [
		.531,
		-.081,
		.525
	],
	8250: [
		.531,
		-.081,
		.525
	],
	8251: [
		.476,
		-.136,
		.525
	],
	8253: [
		.705,
		0,
		.525
	],
	8255: [
		.432,
		-.18,
		.525
	],
	8256: [
		.593,
		-.482,
		.901
	],
	8261: [
		.695,
		.087,
		.525
	],
	8262: [
		.695,
		.082,
		.525
	],
	8274: [
		.695,
		-.001,
		.525
	],
	8276: [
		-.111,
		.222,
		.901
	],
	8319: [
		.549,
		-.287,
		.525
	],
	8320: [
		.183,
		.083,
		.525
	],
	8353: [
		.704,
		.093,
		.525
	],
	8358: [
		.611,
		0,
		.525
	],
	8361: [
		.611,
		.008,
		.525
	],
	8363: [
		.611,
		.062,
		.525
	],
	8369: [
		.611,
		0,
		.525
	],
	8370: [
		.694,
		.083,
		.525
	],
	8451: [
		.623,
		.01,
		.525
	],
	8470: [
		.618,
		.005,
		.525,
		{ ic: .002 }
	],
	8471: [
		.525,
		0,
		.525
	],
	8478: [
		.611,
		.011,
		.525
	],
	8480: [
		.705,
		-.336,
		.525
	],
	8482: [
		.705,
		-.336,
		.525
	],
	8494: [
		.621,
		.005,
		.525
	],
	8960: [
		.531,
		-.081,
		.525
	],
	9250: [
		.611,
		.006,
		.525
	],
	9251: [
		.24,
		.132,
		.525
	],
	11800: [
		.388,
		.233,
		.525
	],
	64256: [
		.616,
		0,
		.525,
		{ ic: .048 }
	],
	64257: [
		.616,
		0,
		.525
	],
	64258: [
		.616,
		0,
		.525
	],
	64259: [
		.616,
		0,
		.525,
		{ ic: .004 }
	],
	64260: [
		.616,
		0,
		.525,
		{ ic: .004 }
	],
	64261: [
		0,
		0,
		.525
	],
	64262: [
		0,
		0,
		.525
	],
	65126: [
		.316,
		-.105,
		.525
	],
	184: [
		.045,
		.208,
		.525
	],
	688: [
		.716,
		-.288,
		.525
	],
	689: [
		.719,
		-.287,
		.525
	],
	690: [
		.733,
		-.15,
		.525
	],
	691: [
		.592,
		-.286,
		.525
	],
	692: [
		.545,
		-.24,
		.525
	],
	693: [
		.545,
		-.085,
		.525
	],
	694: [
		.593,
		-.286,
		.525
	],
	695: [
		.588,
		-.284,
		.525
	],
	696: [
		.545,
		-.084,
		.525
	],
	697: [
		.611,
		-.473,
		.525
	],
	698: [
		.611,
		-.479,
		.525
	],
	699: [
		.68,
		-.372,
		.525
	],
	700: [
		.611,
		-.278,
		.525
	],
	701: [
		.611,
		-.303,
		.525
	],
	702: [
		.555,
		-.223,
		.525
	],
	703: [
		.555,
		-.223,
		.525
	],
	704: [
		.7,
		-.343,
		.525
	],
	705: [
		.7,
		-.344,
		.525
	],
	706: [
		.642,
		-.453,
		.525
	],
	707: [
		.642,
		-.453,
		.525
	],
	708: [
		.624,
		-.487,
		.525
	],
	709: [
		.623,
		-.486,
		.525
	],
	712: [
		.611,
		-.378,
		.525
	],
	716: [
		.011,
		.222,
		.525
	],
	718: [
		-.029,
		.162,
		.525
	],
	719: [
		-.029,
		.162,
		.525
	],
	720: [
		.436,
		.006,
		.525
	],
	721: [
		.436,
		-.27,
		.525
	],
	722: [
		.414,
		-.138,
		.525
	],
	723: [
		.414,
		-.138,
		.525
	],
	724: [
		.294,
		-.056,
		.525
	],
	725: [
		.295,
		-.057,
		.525
	],
	726: [
		.294,
		0,
		.525
	],
	727: [
		.308,
		-.123,
		.525
	],
	731: [
		.012,
		.203,
		.525
	],
	733: [
		.638,
		-.485,
		.525
	],
	734: [
		.437,
		-.191,
		.525
	],
	735: [
		.6,
		-.467,
		.525
	],
	736: [
		.545,
		-.147,
		.525
	],
	737: [
		.654,
		-.287,
		.525
	],
	738: [
		.551,
		-.283,
		.525
	],
	739: [
		.545,
		-.287,
		.525
	],
	740: [
		.658,
		-.287,
		.525
	],
	741: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	742: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	743: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	744: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	745: [
		.646,
		.035,
		.525,
		{ ic: .035 }
	],
	746: [
		.646,
		-.226,
		.525,
		{ ic: .019 }
	],
	747: [
		.646,
		.034,
		.525,
		{ ic: .019 }
	],
	748: [
		-.027,
		.164,
		.525
	],
	749: [
		.687,
		-.514,
		.525
	],
	750: [
		.611,
		-.278,
		.525
	],
	751: [
		-.03,
		.19,
		.525
	],
	752: [
		-.03,
		.19,
		.525
	],
	753: [
		-.03,
		.219,
		.525
	],
	754: [
		-.03,
		.219,
		.525
	],
	755: [
		-.029,
		.209,
		.525
	],
	756: [
		.291,
		-.158,
		.525
	],
	757: [
		.308,
		-.155,
		.525
	],
	758: [
		.288,
		-.135,
		.525
	],
	759: [
		-.031,
		.151,
		.525
	],
	760: [
		.431,
		-.11,
		.525
	],
	761: [
		.6,
		-.367,
		.525
	],
	762: [
		.6,
		-.367,
		.525
	],
	763: [
		.134,
		.099,
		.525
	],
	764: [
		.134,
		.099,
		.525
	],
	765: [
		.134,
		.099,
		.525
	],
	766: [
		.134,
		.099,
		.525
	],
	777: [
		.67,
		-.44,
		0,
		{ dx: .263 }
	],
	779: [
		.638,
		-.485,
		0,
		{ dx: .262 }
	],
	781: [
		.629,
		-.483,
		.525
	],
	782: [
		.629,
		-.483,
		.525
	],
	783: [
		.626,
		-.485,
		0,
		{ dx: .261 }
	],
	784: [
		.699,
		-.499,
		.412
	],
	785: [
		.612,
		-.499,
		0,
		{ dx: .262 }
	],
	786: [
		.68,
		-.372,
		.525
	],
	787: [
		.639,
		-.485,
		.525
	],
	788: [
		.639,
		-.485,
		.525
	],
	789: [
		.733,
		-.4,
		.525
	],
	790: [
		-.048,
		.182,
		.272
	],
	791: [
		-.048,
		.182,
		.272
	],
	792: [
		-.059,
		.353,
		.525
	],
	793: [
		-.059,
		.353,
		.525
	],
	794: [
		.72,
		-.487,
		.165,
		{ ic: .034 }
	],
	795: [
		.611,
		-.278,
		.525
	],
	796: [
		-.044,
		.32,
		.525
	],
	797: [
		-.059,
		.297,
		.525
	],
	798: [
		-.059,
		.297,
		.525
	],
	799: [
		-.059,
		.353,
		.525
	],
	800: [
		-.062,
		.247,
		.525
	],
	801: [
		.034,
		.227,
		.525
	],
	802: [
		.034,
		.228,
		.525
	],
	803: [
		-.1,
		.2,
		0,
		{ dx: .262 }
	],
	804: [
		-.061,
		.161,
		.525
	],
	805: [
		-.029,
		.209,
		.525
	],
	806: [
		-.033,
		.231,
		0,
		{ dx: .263 }
	],
	807: [
		.057,
		.208,
		.525
	],
	808: [
		.056,
		.192,
		.525
	],
	809: [
		-.059,
		.292,
		.525
	],
	810: [
		-.127,
		.333,
		.525
	],
	811: [
		-.125,
		.342,
		.525
	],
	812: [
		-.064,
		.219,
		.525
	],
	813: [
		-.064,
		.22,
		.525
	],
	814: [
		-.093,
		.206,
		0,
		{ dx: .262 }
	],
	815: [
		-.093,
		.206,
		0,
		{ dx: .262 }
	],
	816: [
		-.09,
		.21,
		0,
		{ dx: .262 }
	],
	817: [
		-.118,
		.181,
		0,
		{ dx: .262 }
	],
	818: [
		-.118,
		.181,
		0,
		{ dx: .262 }
	],
	819: [
		-.031,
		.201,
		0,
		{ dx: .262 }
	],
	820: [
		.305,
		-.185,
		.525
	],
	821: [
		.267,
		-.207,
		.525
	],
	822: [
		.267,
		-.207,
		.525
	],
	823: [
		.384,
		-.111,
		.525
	],
	825: [
		-.044,
		.32,
		.525
	],
	826: [
		-.128,
		.333,
		.525
	],
	827: [
		-.127,
		.363,
		.525
	],
	828: [
		-.122,
		.297,
		.525
	],
	829: [
		.6,
		-.467,
		.525
	],
	830: [
		.812,
		-.462,
		.525
	],
	831: [
		.672,
		-.462,
		.525
	],
	832: [
		.622,
		-.488,
		.272
	],
	833: [
		.622,
		-.488,
		.272
	],
	834: [
		.639,
		-.528,
		.525
	],
	835: [
		.639,
		-.485,
		.525
	],
	836: [
		.612,
		-.467,
		.525
	],
	837: [
		-.054,
		.184,
		.525
	],
	838: [
		.654,
		-.448,
		.525
	],
	839: [
		-.063,
		.274,
		.525
	],
	840: [
		-.126,
		.272,
		.525
	],
	841: [
		-.06,
		.293,
		.525
	],
	842: [
		.699,
		-.402,
		.525
	],
	843: [
		.698,
		-.405,
		.525
	],
	844: [
		.732,
		-.462,
		.525
	],
	845: [
		-.008,
		.359,
		.525
	],
	846: [
		-.014,
		.352,
		.525
	],
	847: [
		0,
		0,
		0
	],
	848: [
		.813,
		-.462,
		.525
	],
	849: [
		.651,
		-.471,
		.525
	],
	850: [
		.699,
		-.499,
		.412
	],
	851: [
		-.086,
		.327,
		.525
	],
	852: [
		-.027,
		.378,
		.525
	],
	853: [
		-.027,
		.378,
		.525
	],
	854: [
		-.027,
		.378,
		.525
	],
	855: [
		.651,
		-.471,
		.525
	],
	856: [
		.605,
		-.505,
		0,
		{ dx: .062 }
	],
	857: [
		-.031,
		.256,
		.525
	],
	858: [
		-.028,
		.209,
		.525
	],
	859: [
		.763,
		-.366,
		.525
	],
	860: [
		-.124,
		.388,
		.525
	],
	861: [
		.707,
		-.443,
		.525
	],
	862: [
		.637,
		-.573,
		.5
	],
	863: [
		-.113,
		.177,
		0,
		{ dx: -.001 }
	],
	864: [
		.653,
		-.518,
		.525
	],
	865: [
		.707,
		-.443,
		.525
	],
	866: [
		-.008,
		.359,
		.525
	],
	867: [
		.692,
		-.46,
		.525
	],
	868: [
		.694,
		-.462,
		.525
	],
	869: [
		.776,
		-.463,
		.525
	],
	870: [
		.693,
		-.461,
		.525
	],
	871: [
		.687,
		-.458,
		.525
	],
	872: [
		.695,
		-.463,
		.525
	],
	873: [
		.779,
		-.46,
		.525
	],
	874: [
		.779,
		-.464,
		.525
	],
	875: [
		.692,
		-.463,
		.525
	],
	876: [
		.691,
		-.462,
		.525
	],
	877: [
		.749,
		-.459,
		.525
	],
	878: [
		.689,
		-.462,
		.525
	],
	879: [
		.688,
		-.463,
		.525
	],
	7620: [
		.611,
		-.444,
		.525
	],
	7621: [
		.611,
		-.444,
		.525
	],
	7624: [
		.611,
		-.477,
		.525
	],
	7625: [
		.611,
		-.477,
		.525
	],
	9472: [
		.31,
		-.24,
		.525
	],
	9474: [
		.837,
		.355,
		.525
	],
	9484: [
		.31,
		.355,
		.525
	],
	9488: [
		.31,
		.355,
		.525
	],
	9492: [
		.837,
		-.24,
		.525
	],
	9496: [
		.837,
		-.24,
		.525
	],
	9500: [
		.837,
		.355,
		.525
	],
	9508: [
		.837,
		.355,
		.525
	],
	9516: [
		.31,
		.355,
		.525
	],
	9524: [
		.837,
		-.24,
		.525
	],
	9532: [
		.837,
		.355,
		.525
	],
	9552: [
		.39,
		-.16,
		.525
	],
	9553: [
		.837,
		.355,
		.525
	],
	9554: [
		.39,
		.355,
		.525
	],
	9555: [
		.31,
		.355,
		.525
	],
	9556: [
		.39,
		.355,
		.525
	],
	9557: [
		.39,
		.355,
		.525
	],
	9558: [
		.31,
		.355,
		.525
	],
	9559: [
		.39,
		.355,
		.525
	],
	9560: [
		.837,
		-.16,
		.525
	],
	9561: [
		.837,
		-.24,
		.525
	],
	9562: [
		.837,
		-.16,
		.525
	],
	9563: [
		.837,
		-.16,
		.525
	],
	9564: [
		.837,
		-.24,
		.525
	],
	9565: [
		.837,
		-.16,
		.525
	],
	9566: [
		.837,
		.355,
		.525
	],
	9567: [
		.837,
		.355,
		.525
	],
	9568: [
		.837,
		.355,
		.525
	],
	9569: [
		.837,
		.355,
		.525
	],
	9570: [
		.837,
		.355,
		.525
	],
	9571: [
		.837,
		.355,
		.525
	],
	9572: [
		.39,
		.355,
		.525
	],
	9573: [
		.31,
		.355,
		.525
	],
	9574: [
		.39,
		.355,
		.525
	],
	9575: [
		.837,
		-.16,
		.525
	],
	9576: [
		.837,
		-.24,
		.525
	],
	9577: [
		.837,
		-.16,
		.525
	],
	9578: [
		.837,
		.355,
		.525
	],
	9579: [
		.837,
		.355,
		.525
	],
	9773: [
		.593,
		.001,
		.525
	],
	9792: [
		.442,
		.233,
		.525
	],
	9834: [
		.612,
		.04,
		.642
	],
	9901: [
		.523,
		-.091,
		.525,
		{ ic: .09 }
	],
	9902: [
		.679,
		.065,
		.525,
		{ ic: .206 }
	],
	9906: [
		.442,
		.233,
		.525
	],
	10013: [
		.548,
		.018,
		.525
	],
	59908: [
		.766,
		-.499,
		.525
	],
	59909: [
		-.093,
		.206,
		.525
	],
	59910: [
		-.093,
		.206,
		.525
	],
	59913: [
		.766,
		-.499,
		.525
	],
	59915: [
		.842,
		-.499,
		.525
	],
	59917: [
		.612,
		-.499,
		.525
	],
	59920: [
		.772,
		-.499,
		.525
	],
	59927: [
		.743,
		-.487,
		.525
	],
	59930: [
		.743,
		-.487,
		.525
	],
	59932: [
		.819,
		-.487,
		.525
	],
	59934: [
		.749,
		-.487,
		.525
	],
	59935: [
		-.033,
		.231,
		.525
	],
	59942: [
		.626,
		-.485,
		.525
	],
	59946: [
		.807,
		-.51,
		.525
	],
	59948: [
		.766,
		-.51,
		.525
	],
	59951: [
		.807,
		-.51,
		.525
	],
	59957: [
		.67,
		-.44,
		.525
	],
	59962: [
		-.118,
		.181,
		.525
	],
	59966: [
		-.118,
		.181,
		.525
	],
	59970: [
		.79,
		-.492,
		.525
	],
	59973: [
		-.09,
		.21,
		.525
	],
	60163: [
		.807,
		.203,
		.525
	],
	60164: [
		.622,
		.203,
		.525
	],
	60168: [
		.525,
		0,
		.525
	],
	60175: [
		.525,
		0,
		.525
	],
	60176: [
		0,
		0,
		0
	],
	60177: [
		0,
		0,
		0
	],
	60178: [
		0,
		0,
		0
	],
	60182: [
		.549,
		.017,
		.525
	],
	60185: [
		-.1,
		.2,
		.525
	],
	60190: [
		.807,
		.203,
		.525
	],
	60191: [
		.622,
		.203,
		.525
	],
	60201: [
		.389,
		.316,
		.525
	],
	60203: [
		.704,
		.093,
		.525
	],
	60209: [
		.432,
		-.18,
		.525
	],
	60213: [
		.807,
		.203,
		.525
	],
	60214: [
		.622,
		.203,
		.525
	],
	60218: [
		.807,
		.011,
		.525
	],
	60219: [
		.622,
		.228,
		.525
	],
	60224: [
		.635,
		.021,
		.525,
		{ ic: .032 }
	],
	60232: [
		.807,
		.203,
		.525
	],
	60233: [
		.622,
		.203,
		.525
	],
	60237: [
		.183,
		.083,
		.525
	],
	60259: [
		.639,
		-.443,
		.525,
		{ ic: .164 }
	],
	60261: [
		.593,
		-.482,
		.525,
		{ ic: .149 }
	],
	60270: [
		.611,
		.206,
		.525
	],
	60271: [
		.431,
		.206,
		.525
	],
	60424: [
		.783,
		0,
		.525
	],
	60425: [
		.783,
		0,
		.525
	],
	60426: [
		.783,
		0,
		.525
	],
	60427: [
		.783,
		0,
		.525
	],
	60428: [
		.783,
		0,
		.525
	],
	60429: [
		.725,
		.006,
		.525
	],
	60430: [
		.753,
		0,
		.525
	],
	60432: [
		.775,
		.163,
		.525
	],
	60433: [
		.594,
		.163,
		.525
	],
	61699: [
		.622,
		.011,
		.525
	],
	61700: [
		.297,
		-.235,
		.525
	],
	61705: [
		.123,
		0,
		.525
	],
	61719: [
		.384,
		-.111,
		.525
	],
	61720: [
		.654,
		.014,
		.525
	],
	61721: [
		.644,
		.008,
		.525
	],
	61722: [
		.611,
		.227,
		.525
	],
	61723: [
		.43,
		.227,
		.525
	],
	61724: [
		.611,
		.166,
		.525
	],
	61725: [
		.611,
		.166,
		.525
	],
	61726: [
		.611,
		.166,
		.525
	],
	61729: [
		.43,
		.138,
		.525
	],
	61730: [
		.43,
		.138,
		.525
	],
	61731: [
		.436,
		.355,
		.525
	],
	61734: [
		.611,
		.166,
		.525
	],
	61735: [
		.622,
		.011,
		.525
	],
	61736: [
		.43,
		.138,
		.525
	],
	61737: [
		.439,
		.005,
		.525
	],
	61738: [
		.611,
		.227,
		.525
	],
	61739: [
		.611,
		.227,
		.525
	],
	61740: [
		.43,
		.227,
		.525
	],
	61741: [
		.436,
		.361,
		.525
	],
	61743: [
		.603,
		.14,
		.525
	],
	61747: [
		.651,
		0,
		.525
	],
	61748: [
		.782,
		0,
		.525
	],
	61749: [
		.436,
		.005,
		.525,
		{ ic: .001 }
	],
	61750: [
		.638,
		.005,
		.525
	],
	61751: [
		-.001,
		.314,
		.525
	],
	61752: [
		0,
		.225,
		.525,
		{ ic: .001 }
	],
	61757: [
		.639,
		-.48,
		.525
	],
	61761: [
		.61,
		-.477,
		.525
	],
	61762: [
		.61,
		-.477,
		.525
	],
	61763: [
		.294,
		0,
		.525
	],
	61764: [
		.294,
		0,
		.525
	],
	61765: [
		.611,
		-.354,
		.525
	],
	61766: [
		.586,
		-.358,
		.525
	],
	61771: [
		.035,
		.035,
		.525,
		{ ic: .035 }
	],
	61772: [
		.187,
		.034,
		.525,
		{ ic: .035 }
	],
	61773: [
		.34,
		.034,
		.525,
		{ ic: .035 }
	],
	61774: [
		.493,
		.034,
		.525,
		{ ic: .035 }
	],
	61775: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	61776: [
		.187,
		.034,
		.525,
		{ ic: .035 }
	],
	61777: [
		.34,
		.034,
		.525,
		{ ic: .035 }
	],
	61778: [
		.493,
		.034,
		.525,
		{ ic: .035 }
	],
	61779: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	61780: [
		.035,
		.035,
		.525,
		{ ic: .035 }
	],
	61781: [
		.187,
		.034,
		.525,
		{ ic: .035 }
	],
	61782: [
		.34,
		.034,
		.525,
		{ ic: .035 }
	],
	61783: [
		.493,
		.034,
		.525,
		{ ic: .035 }
	],
	61784: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	61785: [
		.187,
		.034,
		.525,
		{ ic: .035 }
	],
	61786: [
		.34,
		.034,
		.525,
		{ ic: .035 }
	],
	61787: [
		.493,
		.034,
		.525,
		{ ic: .035 }
	],
	61788: [
		.646,
		.034,
		.525,
		{ ic: .035 }
	],
	61791: [
		.611,
		-.444,
		.525
	],
	61792: [
		.611,
		-.444,
		.525
	],
	61793: [
		.611,
		-.477,
		.525
	],
	61794: [
		.611,
		-.477,
		.525
	],
	61795: [
		.611,
		-.478,
		.525
	],
	61796: [
		.611,
		-.478,
		.525
	],
	61797: [
		.436,
		.222,
		.525
	],
	61800: [
		.439,
		.008,
		.525
	],
	61804: [
		.431,
		.227,
		.525
	],
	61805: [
		.03,
		.228,
		.525
	],
	61806: [
		.12,
		.228,
		.525
	],
	61807: [
		.12,
		.228,
		.525
	],
	61808: [
		.12,
		.228,
		.525
	],
	61809: [
		.606,
		-.43,
		.525
	],
	61810: [
		.807,
		-.457,
		.525
	],
	61813: [
		.436,
		.005,
		.525
	],
	61817: [
		.62,
		.229,
		.525
	],
	61818: [
		.439,
		.229,
		.525
	],
	61819: [
		.611,
		.005,
		.525
	],
	61822: [
		.436,
		.228,
		.525
	],
	61823: [
		.436,
		.227,
		.525
	],
	61824: [
		.617,
		.227,
		.525,
		{ ic: .052 }
	],
	61826: [
		.611,
		.227,
		.525
	],
	61828: [
		.611,
		0,
		.525,
		{ ic: .004 }
	],
	61829: [
		.436,
		0,
		.525
	],
	61832: [
		.436,
		.028,
		.525
	],
	61833: [
		.436,
		.227,
		.525
	],
	61834: [
		.554,
		.005,
		.525
	],
	61835: [
		.436,
		.262,
		.525
	],
	61836: [
		.43,
		.192,
		.525
	],
	61837: [
		.442,
		.192,
		.525
	],
	61838: [
		.611,
		.065,
		.525
	],
	61839: [
		.611,
		.005,
		.525
	],
	61842: [
		.611,
		0,
		.525
	],
	61850: [
		.43,
		.009,
		.525
	],
	61854: [
		.43,
		0,
		.525
	],
	61855: [
		.43,
		0,
		.525
	],
	61857: [
		.439,
		0,
		.525
	],
	61859: [
		.629,
		-.483,
		.525
	],
	61860: [
		.629,
		-.483,
		.525
	],
	61863: [
		.034,
		.227,
		.525
	],
	61864: [
		.034,
		.228,
		.525
	],
	61865: [
		-.127,
		.333,
		.525
	],
	61866: [
		-.125,
		.342,
		.525
	],
	61867: [
		.267,
		-.207,
		.525
	],
	61868: [
		.384,
		-.111,
		.525
	],
	61869: [
		-.128,
		.333,
		.525
	],
	61870: [
		-.127,
		.363,
		.525
	],
	61871: [
		-.122,
		.297,
		.525
	],
	61872: [
		-.008,
		.359,
		.525
	],
	61873: [
		.65,
		-.442,
		.525,
		{ ic: .028 }
	],
	61874: [
		.622,
		-.483,
		.525
	],
	61875: [
		.622,
		-.483,
		.525
	],
	61876: [
		.758,
		.286,
		.525,
		{ ic: .127 }
	],
	61877: [
		.854,
		.382,
		.525,
		{ ic: .206 }
	],
	62082: [
		.088,
		0,
		.525
	],
	62083: [
		.727,
		-.496,
		.525
	],
	62110: [
		.649,
		-.484,
		.525
	],
	62113: [
		.611,
		.011,
		.525
	],
	62116: [
		.611,
		0,
		.525
	],
	62119: [
		.611,
		0,
		.525
	],
	62120: [
		.611,
		.166,
		.525
	],
	62121: [
		.431,
		.005,
		.525
	],
	62124: [
		.43,
		0,
		.525
	],
	62126: [
		.43,
		0,
		.525
	],
	62127: [
		.43,
		.138,
		.525
	],
	62560: [
		.807,
		0,
		.525
	],
	62561: [
		.793,
		0,
		.525
	],
	62562: [
		.793,
		0,
		.525
	],
	62563: [
		.807,
		.011,
		.525
	],
	62564: [
		.793,
		.011,
		.525
	],
	62565: [
		.793,
		0,
		.525
	],
	62566: [
		.793,
		.011,
		.525
	],
	62567: [
		.793,
		.011,
		.525
	],
	62568: [
		.793,
		0,
		.525
	],
	62570: [
		.639,
		.006,
		.525
	],
	62571: [
		.639,
		.006,
		.525
	],
	62572: [
		.622,
		0,
		.525
	],
	62573: [
		.639,
		.006,
		.525
	],
	62574: [
		.622,
		.228,
		.525
	],
	62575: [
		.622,
		0,
		.525
	],
	62576: [
		.622,
		.005,
		.525
	],
	62577: [
		.622,
		.005,
		.525
	],
	62578: [
		.622,
		0,
		.525
	],
	63166: [
		.431,
		.228,
		.525
	],
	63187: [
		.807,
		-.686,
		.525
	],
	63188: [
		.656,
		-.493,
		.525
	],
	63189: [
		.644,
		-.483,
		.525
	],
	63190: [
		.639,
		-.506,
		.525
	],
	63198: [
		.341,
		-.271,
		.525
	],
	8592: [
		.481,
		-.131,
		.525
	],
	8593: [
		.611,
		0,
		.525
	],
	8594: [
		.481,
		-.131,
		.525
	],
	8595: [
		.611,
		0,
		.525
	],
	8730: [
		.682,
		.006,
		.525,
		{ ic: .068 }
	],
	8738: [
		.531,
		-.081,
		.525
	],
	9001: [
		.695,
		.083,
		.525
	],
	9002: [
		.695,
		.083,
		.525
	],
	9702: [
		.372,
		-.096,
		.525
	],
	10214: [
		.696,
		.082,
		.525
	],
	10215: [
		.695,
		.082,
		.525
	],
	592: [
		.436,
		.008,
		.525
	],
	593: [
		.436,
		.005,
		.525
	],
	594: [
		.436,
		.005,
		.525
	],
	595: [
		.617,
		.005,
		.525
	],
	596: [
		.436,
		.008,
		.525
	],
	597: [
		.439,
		.166,
		.525
	],
	598: [
		.611,
		.227,
		.525,
		{ ic: .051 }
	],
	599: [
		.617,
		.005,
		.525,
		{ ic: .077 }
	],
	600: [
		.44,
		.006,
		.525
	],
	601: [
		.44,
		.006,
		.525
	],
	602: [
		.436,
		.008,
		.525
	],
	603: [
		.439,
		.005,
		.525
	],
	604: [
		.442,
		.011,
		.525
	],
	605: [
		.442,
		.011,
		.525,
		{ ic: .034 }
	],
	606: [
		.442,
		.011,
		.525
	],
	607: [
		.43,
		.228,
		.525
	],
	608: [
		.555,
		.234,
		.525,
		{ ic: .077 }
	],
	609: [
		.436,
		.234,
		.525
	],
	610: [
		.439,
		.008,
		.525
	],
	611: [
		.43,
		.233,
		.525
	],
	612: [
		.442,
		.011,
		.525
	],
	613: [
		.43,
		.222,
		.525
	],
	614: [
		.617,
		0,
		.525
	],
	615: [
		.617,
		.227,
		.525
	],
	616: [
		.611,
		0,
		.525
	],
	617: [
		.431,
		.005,
		.525
	],
	618: [
		.43,
		0,
		.525
	],
	619: [
		.611,
		0,
		.525
	],
	620: [
		.611,
		0,
		.525
	],
	621: [
		.611,
		.228,
		.525
	],
	622: [
		.611,
		.227,
		.525
	],
	623: [
		.43,
		.005,
		.525,
		{ ic: .003 }
	],
	624: [
		.43,
		.222,
		.525,
		{ ic: .003 }
	],
	625: [
		.436,
		.227,
		.525
	],
	626: [
		.436,
		.227,
		.525
	],
	627: [
		.436,
		.227,
		.525,
		{ ic: .052 }
	],
	628: [
		.43,
		0,
		.525
	],
	629: [
		.439,
		.005,
		.525
	],
	630: [
		.439,
		.008,
		.525
	],
	631: [
		.464,
		.005,
		.525
	],
	632: [
		.611,
		.222,
		.525
	],
	633: [
		.43,
		.005,
		.525
	],
	634: [
		.653,
		.005,
		.525
	],
	635: [
		.43,
		.228,
		.525,
		{ ic: .074 }
	],
	636: [
		.436,
		.222,
		.525
	],
	637: [
		.436,
		.228,
		.525
	],
	638: [
		.436,
		0,
		.525
	],
	639: [
		.436,
		0,
		.525
	],
	640: [
		.43,
		.008,
		.525
	],
	641: [
		.439,
		0,
		.525
	],
	642: [
		.439,
		.227,
		.525
	],
	643: [
		.617,
		.227,
		.525
	],
	644: [
		.555,
		.228,
		.525
	],
	645: [
		.436,
		.227,
		.525
	],
	646: [
		.617,
		.259,
		.525
	],
	647: [
		.436,
		.123,
		.525
	],
	648: [
		.554,
		.227,
		.525
	],
	649: [
		.43,
		.005,
		.525
	],
	650: [
		.43,
		.011,
		.525
	],
	651: [
		.435,
		.005,
		.525
	],
	652: [
		.435,
		0,
		.525
	],
	653: [
		.435,
		0,
		.525
	],
	654: [
		.658,
		0,
		.525
	],
	655: [
		.43,
		0,
		.525
	],
	656: [
		.43,
		.228,
		.525,
		{ ic: .091 }
	],
	657: [
		.43,
		.167,
		.525
	],
	658: [
		.43,
		.228,
		.525
	],
	659: [
		.43,
		.259,
		.525
	],
	660: [
		.617,
		0,
		.525
	],
	661: [
		.617,
		0,
		.525
	],
	662: [
		.611,
		.005,
		.525
	],
	663: [
		.62,
		.228,
		.525
	],
	664: [
		.623,
		.011,
		.525
	],
	665: [
		.43,
		0,
		.525
	],
	666: [
		.442,
		.011,
		.525
	],
	667: [
		.585,
		.008,
		.525,
		{ ic: .063 }
	],
	668: [
		.43,
		0,
		.525
	],
	669: [
		.611,
		.227,
		.525,
		{ ic: .002 }
	],
	670: [
		.431,
		.222,
		.525
	],
	671: [
		.43,
		0,
		.525
	],
	672: [
		.555,
		.222,
		.525,
		{ ic: .077 }
	],
	673: [
		.617,
		0,
		.525
	],
	674: [
		.617,
		0,
		.525
	],
	675: [
		.611,
		.006,
		.525
	],
	676: [
		.611,
		.227,
		.525
	],
	677: [
		.611,
		.167,
		.525
	],
	678: [
		.554,
		.006,
		.525
	],
	679: [
		.617,
		.227,
		.525
	],
	680: [
		.554,
		.166,
		.525
	],
	681: [
		.617,
		.233,
		.525
	],
	682: [
		.611,
		0,
		.525
	],
	683: [
		.611,
		0,
		.525
	],
	684: [
		.613,
		.004,
		.525
	],
	685: [
		.478,
		.001,
		.525
	],
	686: [
		.436,
		.222,
		.525
	],
	687: [
		.436,
		.227,
		.525,
		{ ic: .02 }
	],
	7424: [
		.439,
		.001,
		.525
	],
	7431: [
		.43,
		0,
		.525
	],
	7434: [
		.43,
		.008,
		.525
	],
	7435: [
		.43,
		0,
		.525
	],
	7437: [
		.43,
		0,
		.525
	],
	7448: [
		.431,
		0,
		.525
	],
	7449: [
		.43,
		.008,
		.525
	],
	7452: [
		.43,
		.008,
		.525
	],
	7491: [
		.55,
		-.284,
		.525
	],
	7492: [
		.549,
		-.282,
		.525
	],
	7493: [
		.55,
		-.284,
		.525
	],
	7494: [
		.551,
		-.283,
		.525
	],
	7495: [
		.653,
		-.283,
		.525
	],
	7496: [
		.654,
		-.284,
		.525
	],
	7497: [
		.55,
		-.283,
		.525
	],
	7498: [
		.549,
		-.282,
		.525
	],
	7499: [
		.55,
		-.284,
		.525
	],
	7501: [
		.552,
		-.15,
		.525
	],
	7503: [
		.654,
		-.287,
		.525
	],
	7504: [
		.549,
		-.287,
		.525
	],
	7505: [
		.549,
		-.15,
		.525
	],
	7506: [
		.551,
		-.284,
		.525
	],
	7507: [
		.55,
		-.282,
		.525
	],
	7510: [
		.549,
		-.154,
		.525
	],
	7511: [
		.619,
		-.283,
		.525
	],
	7512: [
		.545,
		-.284,
		.525
	],
	7514: [
		.545,
		-.283,
		.525
	],
	7515: [
		.545,
		-.284,
		.525
	],
	7517: [
		.674,
		-.147,
		.525
	],
	7518: [
		.548,
		-.181,
		.525
	],
	7520: [
		.552,
		-.147,
		.525
	],
	7521: [
		.55,
		-.149,
		.525
	],
	7544: [
		.545,
		-.287,
		.525
	],
	7568: [
		.439,
		.227,
		.525,
		{ ic: .088 }
	],
	7569: [
		.617,
		.227,
		.525
	],
	7570: [
		.439,
		.227,
		.525,
		{ ic: .099 }
	],
	7571: [
		.442,
		.227,
		.525,
		{ ic: .056 }
	],
	7575: [
		.436,
		.227,
		.525
	],
	880: [
		.611,
		0,
		.525
	],
	881: [
		.512,
		0,
		.525
	],
	882: [
		.611,
		0,
		.525
	],
	883: [
		.512,
		0,
		.525
	],
	884: [
		.612,
		-.473,
		.525
	],
	885: [
		0,
		.139,
		.525
	],
	886: [
		.611,
		0,
		.525
	],
	887: [
		.512,
		0,
		.525
	],
	890: [
		-.054,
		.184,
		.525
	],
	891: [
		.44,
		.006,
		.525
	],
	892: [
		.44,
		.006,
		.525
	],
	893: [
		.44,
		.006,
		.525
	],
	894: [
		.43,
		.138,
		.525
	],
	895: [
		.611,
		.011,
		.525
	],
	900: [
		.611,
		-.473,
		.525
	],
	901: [
		.612,
		-.473,
		.525
	],
	902: [
		.623,
		0,
		.525
	],
	903: [
		.43,
		-.305,
		.525
	],
	904: [
		.623,
		0,
		.525
	],
	905: [
		.623,
		0,
		.525
	],
	906: [
		.623,
		0,
		.525
	],
	908: [
		.623,
		.011,
		.525
	],
	910: [
		.623,
		0,
		.525
	],
	911: [
		.623,
		0,
		.525
	],
	912: [
		.612,
		.005,
		.525
	],
	938: [
		.782,
		0,
		.525
	],
	939: [
		.782,
		0,
		.525
	],
	940: [
		.612,
		.005,
		.525,
		{ ic: .001 }
	],
	941: [
		.612,
		.011,
		.525
	],
	942: [
		.612,
		.233,
		.525
	],
	943: [
		.612,
		.005,
		.525
	],
	944: [
		.612,
		.005,
		.525
	],
	970: [
		.586,
		.005,
		.525
	],
	971: [
		.586,
		.005,
		.525
	],
	972: [
		.612,
		.005,
		.525
	],
	973: [
		.612,
		.005,
		.525
	],
	974: [
		.612,
		.005,
		.525
	],
	975: [
		.611,
		.216,
		.525
	],
	976: [
		.636,
		.011,
		.525
	],
	979: [
		.64,
		0,
		.525
	],
	980: [
		.769,
		0,
		.525
	],
	983: [
		.452,
		.228,
		.525
	],
	984: [
		.644,
		0,
		.525
	],
	985: [
		.607,
		.055,
		.525
	],
	986: [
		.639,
		.027,
		.525
	],
	987: [
		.442,
		.017,
		.525
	],
	988: [
		.639,
		0,
		.525
	],
	989: [
		.431,
		.222,
		.525
	],
	990: [
		.611,
		.062,
		.525
	],
	991: [
		.54,
		.101,
		.525
	],
	992: [
		.666,
		0,
		.525
	],
	993: [
		.639,
		.011,
		.525
	],
	994: [
		0,
		0,
		.525
	],
	995: [
		0,
		0,
		.525
	],
	1010: [
		.44,
		.006,
		.525
	],
	1011: [
		.605,
		.228,
		.525
	],
	1015: [
		.611,
		0,
		.525
	],
	1016: [
		.612,
		.222,
		.525
	],
	1017: [
		.622,
		.011,
		.525
	],
	1018: [
		.611,
		0,
		.525
	],
	1019: [
		.43,
		.181,
		.525
	],
	1020: [
		.436,
		.222,
		.525
	],
	1021: [
		.622,
		.011,
		.525
	],
	1022: [
		.622,
		.011,
		.525
	],
	1023: [
		.622,
		.011,
		.525
	],
	7936: [
		.654,
		.005,
		.525,
		{ ic: .001 }
	],
	7937: [
		.654,
		.005,
		.525,
		{ ic: .001 }
	],
	7938: [
		.654,
		.005,
		.525,
		{ ic: .001 }
	],
	7939: [
		.654,
		.005,
		.525,
		{ ic: .001 }
	],
	7940: [
		.654,
		.005,
		.525,
		{ ic: .001 }
	],
	7941: [
		.654,
		.005,
		.525,
		{ ic: .001 }
	],
	7942: [
		.72,
		.005,
		.525,
		{ ic: .001 }
	],
	7943: [
		.72,
		.005,
		.525,
		{ ic: .001 }
	],
	7944: [
		.623,
		0,
		.525
	],
	7945: [
		.623,
		0,
		.525
	],
	7946: [
		.623,
		0,
		.525
	],
	7947: [
		.623,
		0,
		.525
	],
	7948: [
		.623,
		0,
		.525
	],
	7949: [
		.623,
		0,
		.525
	],
	7950: [
		.623,
		0,
		.525
	],
	7951: [
		.623,
		0,
		.525
	],
	7952: [
		.656,
		.011,
		.525
	],
	7953: [
		.656,
		.011,
		.525
	],
	7954: [
		.656,
		.011,
		.525
	],
	7955: [
		.656,
		.011,
		.525
	],
	7956: [
		.656,
		.011,
		.525
	],
	7957: [
		.656,
		.011,
		.525
	],
	7960: [
		.622,
		0,
		.525
	],
	7961: [
		.622,
		0,
		.525
	],
	7962: [
		.622,
		0,
		.525
	],
	7963: [
		.622,
		0,
		.525
	],
	7964: [
		.622,
		0,
		.525
	],
	7965: [
		.622,
		0,
		.525
	],
	7968: [
		.656,
		.233,
		.525
	],
	7969: [
		.656,
		.233,
		.525
	],
	7970: [
		.656,
		.233,
		.525
	],
	7971: [
		.656,
		.233,
		.525
	],
	7972: [
		.656,
		.233,
		.525
	],
	7973: [
		.656,
		.233,
		.525
	],
	7974: [
		.722,
		.233,
		.525
	],
	7975: [
		.722,
		.233,
		.525
	],
	7976: [
		.622,
		0,
		.525
	],
	7977: [
		.622,
		0,
		.525
	],
	7978: [
		.622,
		0,
		.525
	],
	7979: [
		.622,
		0,
		.525
	],
	7980: [
		.622,
		0,
		.525
	],
	7981: [
		.622,
		0,
		.525
	],
	7982: [
		.622,
		0,
		.525
	],
	7983: [
		.622,
		0,
		.525
	],
	7984: [
		.654,
		.005,
		.525
	],
	7985: [
		.654,
		.005,
		.525
	],
	7986: [
		.666,
		.005,
		.525
	],
	7987: [
		.666,
		.005,
		.525
	],
	7988: [
		.666,
		.005,
		.525
	],
	7989: [
		.666,
		.005,
		.525
	],
	7990: [
		.72,
		.005,
		.525
	],
	7991: [
		.72,
		.005,
		.525
	],
	7992: [
		.622,
		0,
		.525
	],
	7993: [
		.622,
		0,
		.525
	],
	7994: [
		.622,
		0,
		.525
	],
	7995: [
		.622,
		0,
		.525
	],
	7996: [
		.622,
		0,
		.525
	],
	7997: [
		.622,
		0,
		.525
	],
	7998: [
		.622,
		0,
		.525
	],
	7999: [
		.622,
		0,
		.525
	],
	8e3: [
		.654,
		.005,
		.525
	],
	8001: [
		.654,
		.005,
		.525
	],
	8002: [
		.654,
		.005,
		.525
	],
	8003: [
		.654,
		.005,
		.525
	],
	8004: [
		.654,
		.005,
		.525
	],
	8005: [
		.654,
		.005,
		.525
	],
	8008: [
		.622,
		.011,
		.525
	],
	8009: [
		.622,
		.011,
		.525
	],
	8010: [
		.622,
		.011,
		.525
	],
	8011: [
		.622,
		.011,
		.525
	],
	8012: [
		.622,
		.011,
		.525
	],
	8013: [
		.622,
		.011,
		.525
	],
	8016: [
		.655,
		.005,
		.525
	],
	8017: [
		.655,
		.005,
		.525
	],
	8018: [
		.655,
		.005,
		.525
	],
	8019: [
		.655,
		.005,
		.525
	],
	8020: [
		.655,
		.005,
		.525
	],
	8021: [
		.655,
		.005,
		.525
	],
	8022: [
		.721,
		.005,
		.525
	],
	8023: [
		.721,
		.005,
		.525
	],
	8025: [
		.622,
		0,
		.525
	],
	8027: [
		.622,
		0,
		.525
	],
	8029: [
		.622,
		0,
		.525
	],
	8031: [
		.622,
		0,
		.525
	],
	8032: [
		.655,
		.005,
		.525
	],
	8033: [
		.655,
		.005,
		.525
	],
	8034: [
		.655,
		.005,
		.525
	],
	8035: [
		.655,
		.005,
		.525
	],
	8036: [
		.655,
		.005,
		.525
	],
	8037: [
		.655,
		.005,
		.525
	],
	8038: [
		.721,
		.005,
		.525
	],
	8039: [
		.721,
		.005,
		.525
	],
	8040: [
		.622,
		0,
		.525
	],
	8041: [
		.622,
		0,
		.525
	],
	8042: [
		.622,
		0,
		.525
	],
	8043: [
		.622,
		0,
		.525
	],
	8044: [
		.622,
		0,
		.525
	],
	8045: [
		.622,
		0,
		.525
	],
	8046: [
		.622,
		0,
		.525
	],
	8047: [
		.622,
		0,
		.525
	],
	8048: [
		.639,
		.005,
		.525,
		{ ic: .001 }
	],
	8049: [
		.638,
		.005,
		.525,
		{ ic: .001 }
	],
	8050: [
		.641,
		.011,
		.525
	],
	8051: [
		.64,
		.011,
		.525
	],
	8052: [
		.641,
		.233,
		.525
	],
	8053: [
		.64,
		.233,
		.525
	],
	8054: [
		.639,
		.005,
		.525
	],
	8055: [
		.638,
		.005,
		.525
	],
	8056: [
		.639,
		.005,
		.525
	],
	8057: [
		.638,
		.005,
		.525
	],
	8058: [
		.64,
		.005,
		.525
	],
	8059: [
		.639,
		.005,
		.525
	],
	8060: [
		.64,
		.005,
		.525
	],
	8061: [
		.639,
		.005,
		.525
	],
	8064: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8065: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8066: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8067: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8068: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8069: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8070: [
		.694,
		.184,
		.525,
		{ ic: .001 }
	],
	8071: [
		.694,
		.184,
		.525,
		{ ic: .001 }
	],
	8072: [
		.623,
		.184,
		.525
	],
	8073: [
		.623,
		.184,
		.525
	],
	8074: [
		.623,
		.184,
		.525
	],
	8075: [
		.623,
		.184,
		.525
	],
	8076: [
		.623,
		.184,
		.525
	],
	8077: [
		.623,
		.184,
		.525
	],
	8078: [
		.623,
		.184,
		.525
	],
	8079: [
		.623,
		.184,
		.525
	],
	8080: [
		.639,
		.233,
		.525
	],
	8081: [
		.639,
		.233,
		.525
	],
	8082: [
		.639,
		.233,
		.525
	],
	8083: [
		.639,
		.233,
		.525
	],
	8084: [
		.639,
		.233,
		.525
	],
	8085: [
		.639,
		.233,
		.525
	],
	8086: [
		.694,
		.233,
		.525
	],
	8087: [
		.694,
		.233,
		.525
	],
	8088: [
		.622,
		.184,
		.525
	],
	8089: [
		.622,
		.184,
		.525
	],
	8090: [
		.622,
		.184,
		.525
	],
	8091: [
		.622,
		.184,
		.525
	],
	8092: [
		.622,
		.184,
		.525
	],
	8093: [
		.622,
		.184,
		.525
	],
	8094: [
		.622,
		.184,
		.525
	],
	8095: [
		.622,
		.184,
		.525
	],
	8096: [
		.639,
		.184,
		.525
	],
	8097: [
		.639,
		.184,
		.525
	],
	8098: [
		.639,
		.184,
		.525
	],
	8099: [
		.639,
		.184,
		.525
	],
	8100: [
		.639,
		.184,
		.525
	],
	8101: [
		.639,
		.184,
		.525
	],
	8102: [
		.694,
		.184,
		.525
	],
	8103: [
		.694,
		.184,
		.525
	],
	8104: [
		.622,
		.184,
		.525
	],
	8105: [
		.622,
		.184,
		.525
	],
	8106: [
		.622,
		.184,
		.525
	],
	8107: [
		.622,
		.184,
		.525
	],
	8108: [
		.622,
		.184,
		.525
	],
	8109: [
		.622,
		.184,
		.525
	],
	8110: [
		.622,
		.184,
		.525
	],
	8111: [
		.622,
		.184,
		.525
	],
	8112: [
		.619,
		.005,
		.525,
		{ ic: .001 }
	],
	8113: [
		.577,
		.005,
		.525,
		{ ic: .001 }
	],
	8114: [
		.612,
		.184,
		.525,
		{ ic: .001 }
	],
	8115: [
		.436,
		.184,
		.525,
		{ ic: .001 }
	],
	8116: [
		.612,
		.184,
		.525,
		{ ic: .001 }
	],
	8118: [
		.639,
		.005,
		.525,
		{ ic: .001 }
	],
	8119: [
		.639,
		.184,
		.525,
		{ ic: .001 }
	],
	8120: [
		.796,
		0,
		.525
	],
	8121: [
		.746,
		0,
		.525
	],
	8122: [
		.623,
		0,
		.525
	],
	8123: [
		.623,
		0,
		.525
	],
	8124: [
		.651,
		.169,
		.525
	],
	8125: [
		.639,
		-.485,
		.525
	],
	8126: [
		.135,
		.135,
		.525
	],
	8127: [
		.639,
		-.485,
		.525
	],
	8128: [
		.639,
		-.535,
		.525
	],
	8129: [
		.764,
		-.51,
		.525
	],
	8130: [
		.612,
		.233,
		.525
	],
	8131: [
		.442,
		.233,
		.525
	],
	8132: [
		.612,
		.233,
		.525
	],
	8134: [
		.639,
		.233,
		.525
	],
	8135: [
		.639,
		.233,
		.525
	],
	8136: [
		.622,
		0,
		.525
	],
	8137: [
		.623,
		0,
		.525
	],
	8138: [
		.622,
		0,
		.525
	],
	8139: [
		.623,
		0,
		.525
	],
	8140: [
		.639,
		.169,
		.525
	],
	8141: [
		.639,
		-.485,
		.525
	],
	8142: [
		.639,
		-.485,
		.525
	],
	8143: [
		.694,
		-.474,
		.525
	],
	8144: [
		.613,
		.005,
		.525
	],
	8145: [
		.571,
		.005,
		.525
	],
	8146: [
		.639,
		.005,
		.525
	],
	8147: [
		.639,
		.005,
		.525
	],
	8150: [
		.604,
		.005,
		.525
	],
	8151: [
		.773,
		.005,
		.525
	],
	8152: [
		.795,
		0,
		.525
	],
	8153: [
		.745,
		0,
		.525
	],
	8154: [
		.622,
		0,
		.525
	],
	8155: [
		.623,
		0,
		.525
	],
	8157: [
		.639,
		-.485,
		.525
	],
	8158: [
		.639,
		-.485,
		.525
	],
	8159: [
		.694,
		-.474,
		.525
	],
	8160: [
		.608,
		.005,
		.525
	],
	8161: [
		.566,
		.005,
		.525
	],
	8162: [
		.64,
		.005,
		.525
	],
	8163: [
		.64,
		.005,
		.525
	],
	8164: [
		.639,
		.222,
		.525
	],
	8165: [
		.639,
		.222,
		.525
	],
	8166: [
		.639,
		.005,
		.525
	],
	8167: [
		.755,
		.005,
		.525
	],
	8168: [
		.795,
		0,
		.525
	],
	8169: [
		.745,
		0,
		.525
	],
	8170: [
		.622,
		0,
		.525
	],
	8171: [
		.623,
		0,
		.525
	],
	8172: [
		.622,
		0,
		.525
	],
	8173: [
		.612,
		-.473,
		.525
	],
	8174: [
		.612,
		-.473,
		.525
	],
	8175: [
		.612,
		-.473,
		.525
	],
	8178: [
		.612,
		.184,
		.525
	],
	8179: [
		.441,
		.184,
		.525
	],
	8180: [
		.612,
		.184,
		.525
	],
	8182: [
		.639,
		.005,
		.525
	],
	8183: [
		.639,
		.184,
		.525
	],
	8184: [
		.622,
		.011,
		.525
	],
	8185: [
		.623,
		.011,
		.525
	],
	8186: [
		.622,
		0,
		.525
	],
	8187: [
		.623,
		0,
		.525
	],
	8188: [
		.622,
		.169,
		.525
	],
	8189: [
		.611,
		-.473,
		.525
	],
	8190: [
		.639,
		-.485,
		.525
	],
	1024: [
		.807,
		0,
		.525
	],
	1025: [
		.819,
		0,
		.525
	],
	1026: [
		.611,
		.011,
		.525
	],
	1027: [
		.807,
		0,
		.525
	],
	1028: [
		.622,
		.011,
		.525
	],
	1029: [
		.622,
		.011,
		.525
	],
	1030: [
		.611,
		0,
		.525
	],
	1031: [
		.819,
		0,
		.525
	],
	1032: [
		.611,
		.011,
		.525
	],
	1033: [
		.611,
		.011,
		.525
	],
	1034: [
		.611,
		0,
		.525
	],
	1035: [
		.611,
		0,
		.525
	],
	1036: [
		.807,
		0,
		.525
	],
	1037: [
		.807,
		0,
		.525
	],
	1038: [
		.837,
		.011,
		.525
	],
	1039: [
		.611,
		.166,
		.525
	],
	1040: [
		.623,
		0,
		.525
	],
	1041: [
		.611,
		0,
		.525
	],
	1042: [
		.611,
		0,
		.525
	],
	1043: [
		.611,
		0,
		.525
	],
	1044: [
		.611,
		.166,
		.525
	],
	1045: [
		.611,
		0,
		.525
	],
	1046: [
		.611,
		0,
		.525
	],
	1047: [
		.622,
		.011,
		.525
	],
	1048: [
		.611,
		0,
		.525
	],
	1049: [
		.837,
		0,
		.525
	],
	1050: [
		.611,
		0,
		.525
	],
	1051: [
		.611,
		.011,
		.525
	],
	1052: [
		.611,
		0,
		.525
	],
	1053: [
		.611,
		0,
		.525
	],
	1054: [
		.622,
		.011,
		.525
	],
	1055: [
		.611,
		0,
		.525
	],
	1056: [
		.611,
		0,
		.525
	],
	1057: [
		.622,
		.011,
		.525
	],
	1058: [
		.611,
		0,
		.525
	],
	1059: [
		.611,
		.011,
		.525
	],
	1060: [
		.611,
		0,
		.525
	],
	1061: [
		.611,
		0,
		.525
	],
	1062: [
		.611,
		.166,
		.525
	],
	1063: [
		.611,
		0,
		.525
	],
	1064: [
		.611,
		0,
		.525
	],
	1065: [
		.611,
		.166,
		.525
	],
	1066: [
		.611,
		0,
		.525
	],
	1067: [
		.611,
		0,
		.525
	],
	1068: [
		.611,
		0,
		.525
	],
	1069: [
		.622,
		.011,
		.525
	],
	1070: [
		.622,
		.011,
		.525
	],
	1071: [
		.611,
		0,
		.525
	],
	1072: [
		.44,
		.006,
		.525
	],
	1073: [
		.611,
		.005,
		.525
	],
	1074: [
		.431,
		0,
		.525
	],
	1075: [
		.43,
		0,
		.525
	],
	1076: [
		.43,
		.138,
		.525
	],
	1077: [
		.44,
		.006,
		.525
	],
	1078: [
		.43,
		0,
		.525
	],
	1079: [
		.439,
		.005,
		.525
	],
	1080: [
		.43,
		0,
		.525
	],
	1081: [
		.656,
		0,
		.525
	],
	1082: [
		.43,
		0,
		.525
	],
	1083: [
		.43,
		.008,
		.525
	],
	1084: [
		.43,
		0,
		.525
	],
	1085: [
		.43,
		0,
		.525
	],
	1086: [
		.44,
		.006,
		.525
	],
	1087: [
		.43,
		0,
		.525
	],
	1088: [
		.437,
		.222,
		.525
	],
	1089: [
		.44,
		.006,
		.525
	],
	1090: [
		.43,
		0,
		.525
	],
	1091: [
		.431,
		.228,
		.525
	],
	1092: [
		.611,
		.222,
		.525
	],
	1093: [
		.431,
		0,
		.525
	],
	1094: [
		.43,
		.138,
		.525
	],
	1095: [
		.43,
		0,
		.525
	],
	1096: [
		.43,
		0,
		.525
	],
	1097: [
		.43,
		.138,
		.525,
		{ ic: .002 }
	],
	1098: [
		.43,
		0,
		.525
	],
	1099: [
		.43,
		0,
		.525
	],
	1100: [
		.43,
		0,
		.525
	],
	1101: [
		.439,
		.005,
		.525
	],
	1102: [
		.439,
		.005,
		.525
	],
	1103: [
		.43,
		0,
		.525
	],
	1104: [
		.639,
		.006,
		.525
	],
	1105: [
		.61,
		.006,
		.525
	],
	1106: [
		.611,
		.222,
		.525
	],
	1107: [
		.639,
		0,
		.525
	],
	1108: [
		.439,
		.005,
		.525
	],
	1109: [
		.44,
		.006,
		.525
	],
	1110: [
		.612,
		0,
		.525
	],
	1111: [
		.611,
		0,
		.525
	],
	1112: [
		.612,
		.228,
		.525
	],
	1113: [
		.43,
		.008,
		.525
	],
	1114: [
		.43,
		0,
		.525
	],
	1115: [
		.611,
		0,
		.525
	],
	1116: [
		.639,
		0,
		.525
	],
	1117: [
		.639,
		0,
		.525
	],
	1118: [
		.656,
		.228,
		.525
	],
	1119: [
		.43,
		.138,
		.525
	],
	1120: [
		.622,
		.011,
		.525
	],
	1121: [
		.439,
		.005,
		.525
	],
	1122: [
		.694,
		0,
		.525
	],
	1123: [
		.667,
		0,
		.525
	],
	1124: [
		.622,
		.011,
		.525
	],
	1125: [
		.439,
		.005,
		.525
	],
	1126: [
		.623,
		0,
		.525
	],
	1127: [
		.437,
		0,
		.525
	],
	1128: [
		.623,
		0,
		.525
	],
	1129: [
		.437,
		0,
		.525
	],
	1130: [
		.611,
		0,
		.525
	],
	1131: [
		.43,
		0,
		.525
	],
	1132: [
		.611,
		0,
		.525
	],
	1133: [
		.43,
		0,
		.525
	],
	1134: [
		.76,
		.227,
		.525
	],
	1135: [
		.565,
		.227,
		.525
	],
	1136: [
		.611,
		0,
		.525
	],
	1137: [
		.611,
		.222,
		.525,
		{ ic: .007 }
	],
	1138: [
		.622,
		.011,
		.525
	],
	1139: [
		.442,
		.011,
		.525
	],
	1140: [
		.622,
		.008,
		.525
	],
	1141: [
		.436,
		.008,
		.525
	],
	1142: [
		.807,
		.008,
		.525
	],
	1143: [
		.639,
		.008,
		.525
	],
	1146: [
		.668,
		.057,
		.525
	],
	1147: [
		.483,
		.05,
		.525
	],
	1148: [
		.83,
		.011,
		.525
	],
	1149: [
		.65,
		.005,
		.525
	],
	1150: [
		.82,
		.011,
		.525
	],
	1151: [
		.639,
		.005,
		.525
	],
	1152: [
		.622,
		.233,
		.525
	],
	1153: [
		.444,
		.227,
		.525
	],
	1154: [
		.206,
		.103,
		.525
	],
	1155: [
		.65,
		-.483,
		.525
	],
	1156: [
		.65,
		-.442,
		.525,
		{ ic: .028 }
	],
	1157: [
		.622,
		-.483,
		.525
	],
	1158: [
		.622,
		-.483,
		.525
	],
	1160: [
		.758,
		.286,
		.525,
		{ ic: .127 }
	],
	1161: [
		.854,
		.382,
		.525,
		{ ic: .206 }
	],
	1162: [
		.837,
		.166,
		.525
	],
	1163: [
		.656,
		.138,
		.525
	],
	1164: [
		.611,
		0,
		.525
	],
	1165: [
		.639,
		0,
		.525
	],
	1166: [
		.611,
		0,
		.525
	],
	1167: [
		.436,
		.222,
		.525,
		{ ic: .002 }
	],
	1168: [
		.778,
		0,
		.525
	],
	1169: [
		.498,
		0,
		.525
	],
	1170: [
		.611,
		0,
		.525
	],
	1171: [
		.43,
		0,
		.525
	],
	1172: [
		.611,
		.228,
		.525
	],
	1173: [
		.43,
		.228,
		.525
	],
	1174: [
		.611,
		.166,
		.525
	],
	1175: [
		.43,
		.138,
		.525
	],
	1176: [
		.622,
		.236,
		.525
	],
	1177: [
		.439,
		.236,
		.525
	],
	1178: [
		.611,
		.166,
		.525
	],
	1179: [
		.43,
		.138,
		.525
	],
	1180: [
		.611,
		0,
		.525
	],
	1181: [
		.43,
		0,
		.525
	],
	1182: [
		.611,
		0,
		.525
	],
	1183: [
		.611,
		0,
		.525
	],
	1184: [
		.611,
		0,
		.525
	],
	1185: [
		.431,
		0,
		.525
	],
	1186: [
		.611,
		.166,
		.525
	],
	1187: [
		.43,
		.138,
		.525
	],
	1188: [
		.611,
		0,
		.525
	],
	1189: [
		.431,
		0,
		.525
	],
	1190: [
		.611,
		.228,
		.525
	],
	1191: [
		.43,
		.228,
		.525,
		{ ic: .009 }
	],
	1192: [
		.622,
		.105,
		.525
	],
	1193: [
		.439,
		.105,
		.525
	],
	1194: [
		.622,
		.236,
		.525
	],
	1195: [
		.439,
		.236,
		.525
	],
	1196: [
		.611,
		.166,
		.525
	],
	1197: [
		.43,
		.138,
		.525
	],
	1198: [
		.611,
		0,
		.525
	],
	1199: [
		.43,
		.222,
		.525
	],
	1200: [
		.611,
		0,
		.525
	],
	1201: [
		.43,
		.222,
		.525
	],
	1202: [
		.611,
		.166,
		.525
	],
	1203: [
		.43,
		.138,
		.525
	],
	1204: [
		.611,
		.166,
		.525
	],
	1205: [
		.43,
		.138,
		.525
	],
	1206: [
		.611,
		.166,
		.525
	],
	1207: [
		.43,
		.138,
		.525
	],
	1208: [
		.611,
		0,
		.525
	],
	1209: [
		.43,
		0,
		.525
	],
	1210: [
		.611,
		0,
		.525
	],
	1211: [
		.611,
		0,
		.525
	],
	1212: [
		.622,
		.011,
		.525
	],
	1213: [
		.439,
		.005,
		.525
	],
	1214: [
		.622,
		.226,
		.525
	],
	1215: [
		.439,
		.229,
		.525
	],
	1216: [
		.611,
		0,
		.525
	],
	1217: [
		.819,
		0,
		.525
	],
	1218: [
		.639,
		0,
		.525
	],
	1219: [
		.611,
		.228,
		.525
	],
	1220: [
		.43,
		.227,
		.525
	],
	1221: [
		.611,
		.166,
		.525
	],
	1222: [
		.43,
		.138,
		.525
	],
	1223: [
		.611,
		.227,
		.525
	],
	1224: [
		.43,
		.227,
		.525
	],
	1225: [
		.611,
		.166,
		.525
	],
	1226: [
		.43,
		.138,
		.525
	],
	1227: [
		.611,
		.166,
		.525
	],
	1228: [
		.43,
		.138,
		.525
	],
	1229: [
		.611,
		.167,
		.525
	],
	1230: [
		.43,
		.138,
		.525
	],
	1232: [
		.819,
		0,
		.525
	],
	1233: [
		.639,
		.006,
		.525
	],
	1234: [
		.819,
		0,
		.525
	],
	1235: [
		.611,
		.006,
		.525
	],
	1236: [
		.611,
		0,
		.525
	],
	1237: [
		.439,
		.005,
		.525
	],
	1238: [
		.819,
		0,
		.525
	],
	1239: [
		.639,
		.006,
		.525
	],
	1240: [
		.622,
		.011,
		.525
	],
	1241: [
		.436,
		.005,
		.525
	],
	1242: [
		.819,
		.011,
		.525
	],
	1243: [
		.611,
		.005,
		.525
	],
	1244: [
		.819,
		0,
		.525
	],
	1245: [
		.611,
		0,
		.525
	],
	1246: [
		.819,
		.011,
		.525
	],
	1247: [
		.61,
		.005,
		.525
	],
	1248: [
		.611,
		.011,
		.525
	],
	1249: [
		.43,
		.228,
		.525
	],
	1250: [
		.819,
		0,
		.525
	],
	1251: [
		.622,
		0,
		.525
	],
	1252: [
		.819,
		0,
		.525
	],
	1253: [
		.61,
		0,
		.525
	],
	1254: [
		.819,
		.011,
		.525
	],
	1255: [
		.61,
		.006,
		.525
	],
	1256: [
		.622,
		.011,
		.525
	],
	1257: [
		.439,
		.005,
		.525
	],
	1258: [
		.819,
		.011,
		.525
	],
	1259: [
		.61,
		.005,
		.525
	],
	1260: [
		.819,
		.011,
		.525
	],
	1261: [
		.61,
		.005,
		.525
	],
	1262: [
		.819,
		.011,
		.525
	],
	1263: [
		.622,
		.228,
		.525
	],
	1264: [
		.819,
		.011,
		.525
	],
	1265: [
		.611,
		.228,
		.525
	],
	1266: [
		.807,
		.011,
		.525
	],
	1267: [
		.639,
		.228,
		.525
	],
	1268: [
		.819,
		0,
		.525
	],
	1269: [
		.61,
		0,
		.525
	],
	1270: [
		.611,
		.166,
		.525
	],
	1271: [
		.43,
		.138,
		.525
	],
	1272: [
		.819,
		0,
		.525
	],
	1273: [
		.611,
		0,
		.525
	],
	1276: [
		.611,
		.227,
		.525
	],
	1277: [
		.43,
		.227,
		.525
	],
	1278: [
		.611,
		0,
		.525
	],
	1279: [
		.43,
		0,
		.525
	],
	1298: [
		.611,
		.227,
		.525
	],
	1299: [
		.43,
		.227,
		.525
	],
	1306: [
		.622,
		.139,
		.525
	],
	1307: [
		.437,
		.222,
		.525,
		{ ic: .012 }
	],
	1308: [
		.611,
		.008,
		.525
	],
	1309: [
		.431,
		.004,
		.525
	]
} } }, "NCM"), {}, ["MJX-NCM-MX"]);
//#endregion
